import type { HTMLProps, ReactNode } from 'react';
import type { LinkProps } from 'next/link';

import type { Order } from 'Types/generic';

export enum CellTextAlign {
	Center = 'center',
	Left = 'left',
	Right = 'right',
}

export type ColumnCellProps = {
	cypressId?: string;
	id: string;
	sortDirection?: Order;
	sortable?: boolean;
	text: ReactNode;
	textAlign?: CellTextAlign;
};

export type DatagridHeaderProps = {
	columns?: Array<ColumnCellProps>;
	containerClassName?: string;
	gridClass?: string;
	onSortHandler?: (id: string, sortDirection: Order) => void;
} & HTMLProps<HTMLDivElement>;

export type DatagridHeaderCellProps = ColumnCellProps & {
	index: number;
} & Pick<DatagridHeaderProps, 'onSortHandler'>;

export type DatagridRowProps = {
	cypressId?: string;
	gridClass?: string;
	index: number;
	isActive?: boolean;
	isInteractive?: boolean;
	onClick?: () => void;
} & Partial<Pick<LinkProps, 'as' | 'href'>> &
	HTMLProps<HTMLDivElement>;
